(function() {
	document.addEventListener("DOMContentLoaded", function() {

		var form = document.getElementById("add-card");

		if(form instanceof HTMLFormElement) {
			makeButtonDisabled(true);

			form.addEventListener("input", function(event) {
				event = event || window.event;
				var target  = event.target;
				var isValid = true;

				for (let i = 0; i < this.elements.length; i++) {
					const element = this.elements[i];

					if(element instanceof HTMLInputElement && element.required)
						if(!element.value || element.value === "") isValid = false;
				}

				makeButtonDisabled(!isValid);
			});
		}

		// Submit button switch
		function makeButtonDisabled(flag) {
			var submit = document.getElementById("addCardBtn");
			var disabledClass = "disabled";

			if(submit instanceof HTMLElement) {
				switch (flag) {
					case true:
						submit.disabled = true;
						submit.classList.add(disabledClass);
						break;

					case false:
						submit.disabled = false;
						submit.classList.remove(disabledClass);
						break;
				}
			}
		}

	});
})();